import axios from "@axios"

/**
 * Obtener formas de contacto
 */
export const getContactSources = function() {
    return new Promise((resolve, reject) => {
        axios.get('/contact-sources', {
            params: {
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            }
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })

}

/**
 * Eliminar forma de contacto
 */
export const removeContactSource = function(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`/contact-sources/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
}

/**
 * Crear forma de contacto
 */
export const addContactSource = function(data) {
    return new Promise((resolve, reject) => {
        axios.post('/contact-sources', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })

}